import { styled } from '@mui/material';

import { Link } from 'react-router';

import { memo } from 'react';

import { useI18n } from '@app-velocity/i18n';
import { Tooltip } from '@app-velocity/ui';

import { SinglePath, SinglePathView } from '../../types';
import { ViewPreview } from '../ViewPreview';
import { ScreenConfidence } from '../ScreenConfidence';
import { OuterSlideContainer, PathScreensScroll } from '../PathScreensScroll';
import { useReportContext } from '../../context/useReportContext';
import { ReportPaths } from '../../paths/ReportPaths';

const StyledSlideLink = styled(Link)({
  flex: '0 0 200px',
  height: '250px',
  display: 'block',
  '&:hover': {
    transform: 'scale(1.05)',
  },
  transition: 'transform 0.15s ease-in-out',
});

export type PathScreensProps = {
  path: SinglePath;
  views: SinglePathView[];
};

export const PathScreens = memo(({ path, views }: PathScreensProps) => {
  const { t } = useI18n();
  const { baseURL } = useReportContext();

  return (
    <PathScreensScroll itemCount={views.length}>
      {({ getItemRef, shouldIgnoreClick }) =>
        views.map((view, index) => (
          <OuterSlideContainer
            key={view.checksum || index}
            ref={getItemRef(index)}
          >
            <Tooltip title={t('prototypes:report.paths.see_details')}>
              <StyledSlideLink
                to={ReportPaths.goToSinglePathView(
                  baseURL,
                  path.type,
                  path.id,
                  view.checksum
                )}
                onClick={(event) => {
                  if (shouldIgnoreClick()) {
                    event.preventDefault();
                  }
                }}
              >
                <ViewPreview
                  persona={path.persona || 'default'}
                  personaConfig={path.personaConfig}
                  size="normal"
                  pageId={view.pageId}
                  partials={view.partials}
                  clicks={view.clicks}
                  image={view.image}
                  width={view.width}
                  height={view.height}
                />
              </StyledSlideLink>
            </Tooltip>
            <ScreenConfidence confidence={view.confidence || []} />
          </OuterSlideContainer>
        ))
      }
    </PathScreensScroll>
  );
});
